import { ReactNode } from "react";
import { create } from "zustand";

export interface IDialogOptions {
  disableOutsideClick?: boolean;
}

export interface IDialogStore {
  isOpen: boolean;
  body: ReactNode | null;
  options?: IDialogOptions | undefined;
  openDialog: (content: ReactNode, options?: IDialogOptions) => void;
  closeDialog: () => void;
}

const useDialogStore = create<IDialogStore>((set) => ({
  isOpen: false,
  body: null,
  options: {},
  openDialog: (content, options) => set({ isOpen: true, body: content, options }),
  closeDialog: () => set({ isOpen: false, body: null, options: undefined }),
}));

export default useDialogStore;
